/**
 * Grandfathering helpers; now delegates to @landlordops/shared for the
 * canonical logic so frontend and backend are always in sync.
 *
 * Keep this file as a thin re-export so existing import paths don't break.
 */

export {
  isOpsChatStylePlanKey,
  isGrandfatheredScaleSuite,
  subscriptionAllowsGrandfatheredScale,
} from "@landlordops/shared";

/**
 * @deprecated Date cutover no longer used for the Scale grant; kept for
 * env-variable compatibility with any existing tooling.
 */
export const GRANDFATHER_SCALE_SUITE_CUTOFF_MS = Date.parse(
  (typeof process !== "undefined" &&
    process.env.REACT_APP_GRANDFATHER_SCALE_CUTOFF_ISO) ||
    "2026-04-01T00:00:00.000Z"
);
